import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { OpportunityProbabilityView } from '@api-proxies';
import { OpportunityProbabilityService } from '@http/clients/opportunity-probability.service';
import { EditorComponentBase, GenericDropdownComponent } from 'ngx-lib';
import { ValidationErrorMessageComponent } from '../../validation-error-message/validation-error-message.component';

@Component({
    selector: 'app-opportunity-probability-editor',
    templateUrl: './opportunity-probability-editor.component.html',
    styleUrls: ['./opportunity-probability-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent, ValidationErrorMessageComponent]
})
export class OpportunityProbabilityEditorComponent extends EditorComponentBase<number | null> implements OnInit {
    probabilityItems?: OpportunityProbabilityView[];
    selectedProbability?: OpportunityProbabilityView;

    constructor(private readonly opportunityProbabilityService: OpportunityProbabilityService) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.probabilityItems = await this.opportunityProbabilityService.getAll();
        if (this.bindingProperty)
            this.selectedProbability = this.probabilityItems?.find((x) => x.id === this.bindingProperty);
    }

    onProbabilityChange() {
        if (this.selectedProbability?.id) {
            this.bindingProperty = this.selectedProbability.id;
            this.validate();
        } else {
            this.bindingProperty = null;
        }
        this.valueChange.emit();
    }
}
